<!--
/**
* @name: UserInfo.vue
* @description: 用户信息模板
* @author: 温永江
* @create: 2020/07/22 15:59:46
* @update: 2020/07/22 15:59:46
*/
-->

<template>
  <div :class="css.info">
    <k-dropdown
      :title="userTitle()"
      gap="0"
      alignment="right"
      :show.sync="showUser"
      :layerClassName="css.layer"
      :bodyClassName="css.user"
      :class="[css.item, { [css.active]: showUser }]"
    >
      <div :class="css.user_body">
        <div :class="css.user_btn_group">
          <div :class="css.btn" @click="toEditPwd">
            <k-icon :class="css.icon" name="icon-lock" />
            <span>&#8194;修改密码</span>
          </div>
          <div :class="css.btn" @click="logout">
            <k-icon :class="css.icon" name="icon-quit" />
            <span>&#8194;退出登录</span>
          </div>
        </div>
      </div>
    </k-dropdown>
    <k-popup title="修改密码" :show.sync="show" @after-ok="onSave" @after-close="onClose" @after-cancel="onCancel" @after-enter="afterEnter">
      <div v-loading="{ loading: saving }">
        <y-form>
          <y-form-item title="原密码" required>
            <k-input v-model.trim="info.oldPassword" placeholder="请输入原密码" type="text" />
          </y-form-item>
          <y-form-item title="新密码" required>
            <k-input v-model.trim="info.newPassword" placeholder="请输入新密码" type="text" minlength="10" maxlength="16" />
          </y-form-item>
          <y-form-item title="新密码" required>
            <k-input v-model.trim="newPwd1" placeholder="请再次输入新密码" type="text" minlength="10" maxlength="16" />
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
  </div>
</template>
<script>
import { NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_UPDATE_PASSWORD, NESTLE_SYSTEM_BACK_SERVER_LOGINOUT } from '@/assets/modules/apiList';
export default {
  data() {
    return {
      user: '',
      show: false,
      showUser: false,
      saving: false,
      info: {
        oldPassword: '',
        newPassword: ''
      },
      newPwd1: ''
    };
  },
  methods: {
    logout() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_LOGINOUT,
        para: {}
      })
        .then(data => {
          this.$lf.removeItem('login').then(() => {
            this.$controller.login();
          });
        })
        .catch(err => {});
    },
    getUser() {
      this.$lf.getItem('login').then(login => {
        if (login) {
          this.user = login.username;
          // this.com.CompanyName = login.CompanyName
          // this.com.CompanyCode = login.CompanyCode
          // this.com.CompanyEndDate = login.CompanyEndDate
        }
      });
    },
    userTitle() {
      return [<span class={this.css.text}>欢迎您，{this.user}</span>, <k-icon name="k-icon-sort-down" size="20" class={this.css.icon} />];
    },
    toEditPwd() {
      this.show = true;
      this.showUser = false;
    },
    onClose() {
      this.info.newPassword = '';
      this.info.oldPassword = '';
      this.newPwd1 = '';
    },
    onCancel() {
      this.info.newPassword = '';
      this.info.oldPassword = '';
      this.newPwd1 = '';
    },
    onSave() {
      if (this.saving) {
        return;
      }
      if (this.info.oldPassword === '') {
        return this.$root.tip('请输入原密码');
      }
      if (this.info.newPassword === '') {
        return this.$root.tip('请输入新密码');
      }
      // let reg = /^(?![\\d]+$)(?![a-zA-Z]+$)(?![^\\da-zA-Z]+$).{8,10}/;
      // let reg = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+.])[a-zA-Z\d!@#$%^&*()_+.]{10,16}/;
      let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+.])[a-zA-Z\d!@#$%^&*()_+.]{10,16}$/;
      if (!reg.test(this.info.newPassword)) {
        return this.$root.tip('新密码必须包含大小写字母、数字和特殊字符，且长度不小于10位,不大于16位');
      }
      if (this.newPwd1 === '') {
        return this.$root.tip('请输入确认密码');
      }
      if (!reg.test(this.newPwd1)) {
        return this.$root.tip('确认密码必须包含大小写字母、数字和特殊字符，且长度不小于10位,不大于16位');
      }

      if (this.info.newPassword !== this.newPwd1) {
        return this.$root.tip('两次输入的新密码不一致');
      }
      this.saving = true;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_USER_UPDATE_PASSWORD,
        para: this.info
      })
        .then(data => {
          this.$root.tip('密码修改成功，请重新登录！', 'success');
          this.show = false;
          this.saving = false;
          this.info.newPassword = '';
          this.info.oldPassword = '';
          this.newPwd1 = '';
          this.$controller.login();
        })
        .catch(err => {
          this.saving = false;
        });
    }
  },
  watch: {
    showUser(v) {
      this.$emit('getShow', v);
    },
    show(v) {
      this.$emit('getShow', v);
    }
  },
  mounted() {
    this.getUser();
  }
};
</script>
<style lang="postcss" module="css">
.info {
  height: 38px;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  color: var(--color-font-1);
  padding-right: 10px;
  & .gutter {
    margin: 0 12px;
    height: 17px;
    width: 1px;
    background-color: #999;
  }
  & .item {
    padding: 0 15px;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    cursor: pointer;
    & .text {
      font-size: 12px;
      margin-right: 5px;
    }

    &:hover,
    &.active {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}
.layer {
  border: none;
}
.user {
  max-height: none;
}
.user_body {
  padding: 15px;
  /* height: 350px; */
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: var(--radius);
}
.user_btn_group {
  user-select: none;
  white-space: nowrap;
  & .btn {
    cursor: pointer;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    color: var(--color-font-3);
    transition: var(--transition);
    font-size: 13px;
    &:first-child {
      margin-bottom: 15px;
    }
    &:hover {
      color: var(--color-primary);
    }

    &:active {
      background-color: #f6f6f6;
    }
  }
}
</style>
